import './@types/App.d';

type EstateWithChart = Estate & {
  chart: Promise<Blob>
};

export const DIVIDUALS_CHART_CLASS_NAME = 'dividuals-chart';

export function estateId(estate: Estate) {
  return `estate-${estate.id}`;
}

export function aggregateData(estates: Estate[]): EstateWithChart[] {
  return estates.map(estate => {
    const chart = new Promise<Blob>((resolve, reject) => {
      const canvas: HTMLCanvasElement | null = document.querySelector(`#accordion-panel-${estateId(estate)} .${DIVIDUALS_CHART_CLASS_NAME} canvas`);
      if (canvas === null) {
        reject();
      } else {
        canvas.toBlob(blob => blob ? resolve(blob) : reject(), 'image/png');
      }
    });
    return {...estate, chart};
  });
}
